module.exports = __webpack_public_path__ + "img/setting-04.bddc2ea4.png";